function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ConfirmationModal, TextField, Typography } from 'seagull';
import { useGlobalContext, useStoreActions } from "../../../contexts";
import { requiredValidation } from 'validators';
import { Intent } from "../../../infra/access-control";
function RejectDeliveryModal(_ref) {
  let {
    dismissModal,
    rejectDelivery,
    relationshipId,
    serviceId,
    billCommandId
  } = _ref;
  const {
    api,
    logBI
  } = useStoreActions();
  const {
    control,
    handleSubmit,
    formState
  } = useForm({
    mode: 'all'
  });
  const {
    showErrorToast
  } = useGlobalContext();
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: "Reject delivery",
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, "By rejecting the delivery you will not be billed and you won't be able to download the files. Please explain the reason for rejecting."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Controller, {
      control: control,
      name: "rejectionReason",
      rules: requiredValidation(),
      render: _ref2 => {
        let {
          field
        } = _ref2;
        return /*#__PURE__*/React.createElement(TextField, {
          multiline: true,
          minRows: 4,
          value: field.value,
          onInput: field.onChange,
          "data-testid": "rejection-notes",
          label: "Rejection notes",
          placeholder: "Enter reason here",
          required: true
        });
      }
    })),
    primaryButtonTestid: "sda-modal-reject-delivery-btn",
    primaryButtonLabel: "Reject delivery",
    primaryButtonIntent: Intent.RejectDelivery,
    onPrimaryButtonClick: handleSubmit(data => {
      logBI(11704, {
        serviceId
      });
      api.billCommand.clientRejectsDelivery(relationshipId, serviceId, billCommandId, data).then(() => {
        dismissModal();
        rejectDelivery();
      }, err => {
        showErrorToast(err);
      });
    }),
    primaryButtonDisabled: !formState.isValid,
    secondaryButtonLabel: "Cancel",
    onCloseButtonClick: () => dismissModal(),
    onSecondaryButtonClick: () => dismissModal()
  });
}
export function useRejectDeliveryModal(props) {
  const {
    showModal
  } = useGlobalContext();
  return () => showModal({
    content: _ref3 => {
      let {
        dismissModal
      } = _ref3;
      return /*#__PURE__*/React.createElement(RejectDeliveryModal, _extends({
        dismissModal: dismissModal
      }, props));
    }
  });
}